import React, { useMemo, useState } from "react";
import styles from "./Table.module.scss";
// import PAGINATION_ARROW from "assets/png/arrow.png"
import ReactPaginate from "react-paginate";
import classNames from "classnames";
// import { PAGINATION } from 'utils/constants';
// import { useSelector } from 'react-redux';
import { combineClasses } from "utils/utils";
import ArrowSVG from "components/SVGComponents/ArrowSVG";

const PAGINATION = {};

const Pagination = (props) => {
  const { pageSelected, setPageSelected, rowsPerPageValue, className } = props;
  const noOfPages = useMemo(
    () => Math.ceil(props?.totalCount / rowsPerPageValue),
    [rowsPerPageValue, props?.totalCount]
  );

  const endingData = useMemo(
    () => pageSelected * rowsPerPageValue,
    [pageSelected, rowsPerPageValue]
  );
  const startingData = useMemo(() => {
    if (pageSelected === 1) {
      return 1;
    } else if (endingData > props?.totalCount) {
      return (noOfPages - 1) * rowsPerPageValue + 1;
    } else {
      return (pageSelected - 1) * rowsPerPageValue + 1;
    }
  }, [
    pageSelected,
    rowsPerPageValue,
    endingData,
    props?.totalCount,
    noOfPages,
  ]);

  const handlePageClick = (e) => {
    setPageSelected(e?.selected + 1);
    props?.setPageSelected(e?.selected + 1);
  };

  return (
    <div className={combineClasses(styles.pagination, className)}>
      {/* <p className={styles.dataRange}>
        {`${startingData} - ${
          endingData > props?.totalCount ? props?.totalCount : endingData
        } ${props?.tableName} out of ${props?.totalCount}`}
      </p> */}
      <div className={styles.paginationRightSide}>
        <ReactPaginate
          breakLabel="..."
          breakClassName={styles.page}
          previousClassName={combineClasses(styles.page, styles.arrowBox)}
          previousLabel={
            <ArrowSVG
              className={classNames(styles.arrow, styles.previousArrow)}
            />
          }
          nextClassName={combineClasses(
            styles.page,
            styles.arrowBox,
            pageSelected === noOfPages ? styles.disabled : ""
          )}
          nextLabel={
            <ArrowSVG className={classNames(styles.arrow, styles.nextArrow)} />
          }
          renderOnZeroPageCount={null}
          pageCount={
            Number(props?.totalCount) > 0
              ? Math.ceil(Number(props.totalCount) / rowsPerPageValue)
              : 0
          }
          containerClassName={styles.paginationContainer}
          activeClassName={styles.activePage}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageClick}
          disabledClassName={styles.disabled}
          pageClassName={styles.page}
          forcePage={pageSelected - 1}
        />
      </div>
    </div>
  );
};

export default Pagination;
